export enum Colors {
  // Common
  white = '#FFFFFF',
  black = '#000000',
  // Primary color: Red
  primary50 = '#FCE4E9',
  primary100 = '#F8BAC8',
  primary200 = '#F28EA3',
  primary300 = '#EC6280',
  primary400 = '#E54366',
  primary500 = '#DF2A4F',
  primary600 = '#CF254C',
  primary700 = '#BA2049',
  primary800 = '#A61A46',
  primary900 = '#821240',
  // Secondary color: Slate
  secondary50 = '#F6F5FA',
  secondary100 = '#F0EFF6',
  secondary200 = '#E5E2F2',
  secondary300 = '#D3CFE3',
  secondary400 = '#AFABBD',
  secondary500 = '#8E8A9C',
  secondary600 = '#666374',
  secondary700 = '#535060',
  secondary800 = '#353241',
  secondary900 = '#151220',
  // Tertiary color: Sapphire
  tertiary50 = '#E4F2FD',
  tertiary100 = '#BEDEFB',
  tertiary200 = '#96CAF9',
  tertiary300 = '#6FB5F6',
  tertiary400 = '#55A5F4',
  tertiary500 = '#4296F2',
  tertiary600 = '#3E87E3',
  tertiary700 = '#3975D0',
  tertiary800 = '#3464BE',
  tertiary900 = '#2C469E',
  // Success color: System Green
  success50 = '#E6F8EC',
  success100 = '#C2EED0',
  success200 = '#9AE2B2',
  success300 = '#6BD892',
  success400 = '#40CE79',
  success500 = '#39E09B',
  success600 = '#00B456',
  success700 = '#6BF1E1',
  success800 = '#42B886',
  success900 = '#007029',
  // Error color: System red
  error50 = '#FEEBED',
  error100 = '#FDCDD0',
  error200 = '#EB9A97',
  error300 = '#FF656E',
  error400 = '#E8574C',
  error500 = '#FF545E',
  error600 = '#DD3F31',
  error700 = '#ED5F67',
  error800 = '#BE2F25',
  error900 = '#AF2619',
  // Warning color: Papaya
  warning50 = '#FFF8E3',
  warning100 = '#FFEDB7',
  warning200 = '#FFE289',
  warning300 = '#FFBF5F',
  warning400 = '#FFCD3C',
  warning500 = '#FFB84D',
  warning600 = '#FFB727',
  warning700 = '#EDB25A',
  warning800 = '#FD9421',
  warning900 = '#FC771E',
  // Neutrals color: Grey
  smoke100 = '#F9F9FA',
  smoke200 = '#F0F0F0',
  smoke300 = '#DEDEE2',
  smoke400 = '#C4C4CA',
  smoke500 = '#ACACB4',
  smoke600 = '#94949E',
  smoke700 = '#6A6A76',
  smoke800 = '#3D3D43',
  smoke900 = '#27272B',

  // background
  background_main = '#373D49',
  background_light = '#5B6271',
  background_dark = '#313742',

  // text
  text_light = '#A8AEBF',
  text_main = '#D6D6D6',
  text_dark = '#D0D4E1',

  // divider
  divider_light = '#636B7A',
  divider_main = '#525B6B',
  divider_dark = '#5F6775',
}
